import { Injectable } from "@angular/core";
import { resourceUrlFor } from "./data";
import { HttpService } from "./http.service";
import { Observable, of } from "rxjs";
import { map, share } from "rxjs/operators";

import { Person } from "../resources";
import { BrokerService } from ".";

@Injectable()
export class AuthService {
  baseUrl: string;
  ongoingCache: Observable<Person>;
  cache: Person;

  constructor(private http: HttpService, private broker: BrokerService) {
    this.baseUrl = resourceUrlFor("auth");

    this.ongoingCache = this.http.request(`${this.baseUrl}/currentUser`).pipe(
      map((response) => (this.cache = new Person(response))),
      share()
    );

    this.ongoingCache.subscribe((config) => broker.broadcast("config.service.current", config));
  }

  public getCurrenUser(refreshCache?: boolean) {
    if (!refreshCache && this.cache) {
      return of(this.cache);
    }

    return this.ongoingCache;
  }
}
